// Main js file for the object
export default function global() {
  console.log('global');
}
